export default __webpack_public_path__ + "static/media/resourceForGettingStarted2.e56c7b76.png";